module.exports = __webpack_public_path__ + "img/word.5b9bd24c.png";